import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import IndividualFiltersQuery from '~/QueryHooks/IndividualFiltersQuery'
import { FilterEnums } from './types'
import TableComponent from '~/components/TableComponent'
import { Nullable } from '~/types'

interface Props {
  type: FilterEnums
  id: Nullable<string>
  handleClose: () => void
}

const AssignedModal:React.FC<Props> = (props) => {
  const { type, handleClose, id } = props
  const { t } = useTranslation()

  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0
  })

  const tableColumnHeaders = [
    {
      name: t('Supplier No.'),
      key: 'supplierNo'
    },
    {
      name: t('Company name'),
      key: 'companyName'
    }
  ]
 
  const {
    data: farmers,
    isLoading: isLoadingFarmers,
    refetch: fetchFarmers,
    isFetching: isFetchinFarmers
  } = IndividualFiltersQuery.getAssignedFarmers(
    type,
    id,
    {
      ...dataFiltered,
      page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
    }
  )

  useEffect(() => {
    if(id) {
      fetchFarmers()
    }
  }, [dataFiltered])

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={tableColumnHeaders}
      animated
      isFetchingData={isFetchinFarmers}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      total={filtered}
      rows={rows}
    />
  }

  const { filtered, rows } = farmers ? farmers : { filtered: 0, rows: [] };

  return <Dialog
    isDialogOpen={Boolean(id)}
    handleClose={() => handleClose()}
    isLoading={isLoadingFarmers}
    htmlContent
    minHeight='640px'
    textContent={<>
      {renderTable()}
    </>}
    textHeader={t('Assigned farmers')}
    textClose={t('Close')}
  />
}
export default AssignedModal